export const agreementTranslations = {
  lv: {
    title: 'Līgumi',
    count_zero: '{{count}} līgumu',
    count_one: '{{count}} līgums',
    count_other: '{{count}} līgumi',
    search: 'Meklēt pēc praktikanta, prakses vietas, līguma numura…',
    empty: 'Līgumi nav atrasti',
    statusTabs: 'Līgumu statuss',
    tabs: {
      all: 'Visi',
      toSignEdu: 'Gaida izglītības iestādes parakstu',
      toSignOther: 'Gaida citas puses',
      inProcess: 'Procesā',
      missingData: 'Trūkst datu',
      signed: 'Parakstīti',
    },
    statuses: {
      toSignEdu: 'Gaida izglītības iestādes parakstu',
      toSignIntern: 'Gaida praktikanta parakstu',
      toSignOrg: 'Gaida prakses vietas parakstu',
      missingData: 'Trūkst datu',
      missingOrg: 'Nav prakses vietas',
      signed: 'Parakstīts',
    },
    columns: {
      select: 'Atzīmēt',
      nr: 'Nr.',
      agreementId: 'Līguma ID',
      intern: 'Praktikants',
      internship: 'Prakse',
      org: 'Prakses vieta',
      eduSigned: 'Iestādes paraksts',
      orgSigned: 'Vietas paraksts',
      internSigned: 'Praktikanta paraksts',
      status: 'Statuss',
      agreementStart: 'Sākums',
      agreementEnd: 'Beigas',
    },
    signing: {
      title: 'Līgumu parakstīšana',
      processTitle: 'Parakstīšanas process',
      signAt: 'Parakstīt ar',
      signAtEparaksts: 'Parakstīt ar eParaksts',
      sendToEmail: 'Sūtīt uz e-pastu',
      sendDescription_zero:
        'Saite {{count}} līgumu parakstīšanai tiks nosūtīta uz norādīto e-pastu.',
      sendDescription_one:
        'Saite {{count}} līguma parakstīšanai tiks nosūtīta uz norādīto e-pastu.',
      sendDescription_other:
        'Saite {{count}} līgumu parakstīšanai tiks nosūtīta uz norādīto e-pastu.',
      email: 'E-pasts',
      send: 'Nosūtīt',
      sent: 'Saite parakstīšanai nosūtīta uz {{email}}.',
      skipped_zero: '{{count}} līgumi netika iekļauti.',
      skipped_one: '{{count}} līgums netika iekļauts.',
      skipped_other: '{{count}} līgumi netika iekļauti.',
    },
    eparakstsReturn: {
      title: 'Parakstīšanas rezultāts',
      processing: 'Apstrādā parakstītos līgumus…',
      cancelled: 'Parakstīšana atcelta.',
      failed: 'Parakstīšana neizdevās ({{error}}).',
      notFound: 'Parakstīšanas process nav atrasts.',
      signedCount: 'Parakstīti: {{count}} no {{total}}',
      result: 'Rezultāts',
      checkAgain: 'Pārbaudīt vēlreiz',
    },
    emailSign: {
      title: 'Līgumu parakstīšana',
      notFound: 'Saite nav derīga vai tai beidzies termiņš.',
      request: '{{sender}} lūdz parakstīt līgumus kā: {{party}}.',
      validUntil: 'Saite derīga līdz {{date}}.',
      nothingToSign: 'Šajā saitē vairs nav neviena līguma, ko parakstīt.',
      eduOrg: 'Izglītības iestāde',
    },
    notAssigned: 'Nav piešķirta',
    signed: 'Parakstīts',
    signedBy: 'Parakstīts — {{signatory}}, {{date}}',
    notSigned: 'Nav parakstīts',
    selectAll: 'Atzīmēt visus redzamos',
    selectRow: 'Atzīmēt {{name}}',
    signSelected: 'Parakstīt atzīmētos ({{count}})',
    selectedNone: 'Atzīmējiet līgumus, ko gribat parakstīt',
    selectToSign: 'Atzīmēt parakstīšanai',
    selectToDownload: 'Atzīmēt lejupielādei',
    downloadSelected: 'Lejupielādēt atzīmētos ({{count}})',
    downloadSelectedNone: 'Atzīmējiet līgumus, ko gribat lejupielādēt',
    filters: {
      button: 'Filtri',
      title: 'Filtrēt līgumus',
      clear: 'Notīrīt',
      apply: 'Filtrēt',
      active: 'Aktīvie filtri',
      remove: 'Noņemt filtru “{{filter}}”',
      class: 'Klase',
      group: 'Grupa',
      groupsSelected_zero: '{{count}} grupas',
      groupsSelected_one: '{{count}} grupa',
      groupsSelected_other: '{{count}} grupas',
      groupsPill: 'Grupas ({{total}})',
      internship: 'Prakse',
      internshipsSelected_zero: '{{count}} prakses',
      internshipsSelected_one: '{{count}} prakse',
      internshipsSelected_other: '{{count}} prakses',
      internshipsPill: 'Prakses ({{total}})',
      pick: 'Izvēlēties',
      template: 'Līguma sagatave',
      nrPrefix: 'Prefikss',
      status: 'Statuss',
      statuses: {
        toSignEdu: 'Gatavs parakstīšanai',
        toSignIntern: 'Gaida praktikantu',
        toSignOrg: 'Gaida prakses vietu',
        inProcess: 'Procesā',
        missingData: 'Trūkst datu',
        missingOrg: 'Nav prakses vietas',
        signed: 'Parakstīts',
      },
      all: 'Visas',
      inactive: '{{text}} (neaktīva)',
    },
    internshipPicker: {
      title: 'Izvēlēties prakses',
      class: 'Klase',
      year: 'Gads',
      allYears: 'Visi gadi',
      group: 'Grupa',
      status: 'Statuss',
      statuses: {
        all: 'Visas',
        ongoing: 'Notiek',
        upcoming: 'Gaidāmās',
        finished: 'Beigušās',
      },
      search: 'Meklēt pēc nosaukuma, programmas vai grupas',
      select: 'Izvēlēties',
      none: 'Nav atrasta neviena prakse',
      selected: 'Izvēlētas: {{total}}',
      clearSelection: 'Notīrīt izvēli',
      apply: 'Izvēlēties ({{total}})',
      loadFailed: 'Neizdevās ielādēt prakses',
    },
    groupPicker: {
      title: 'Izvēlēties grupas',
      class: 'Klase',
      year: 'Gads',
      allYears: 'Visi gadi',
      search: 'Meklēt pēc nosaukuma vai apraksta',
      select: 'Izvēlēties',
      columns: {
        group: 'Grupa',
        class: 'Klase',
        students: 'Studenti',
        description: 'Apraksts',
      },
      none: 'Nav atrasta neviena grupa',
      selected: 'Izvēlētas: {{total}}',
      clearSelection: 'Notīrīt izvēli',
      apply: 'Izvēlēties ({{total}})',
      loadFailed: 'Neizdevās ielādēt grupas',
    },
    actions: {
      menu: 'Līguma darbības',
      sign: 'Parakstīt',
      download: 'Lejupielādēt līgumu',
      edit: 'Labot līguma datus',
      uploadSigned: 'Augšupielādēt parakstītu līgumu',
      reset: 'Atiestatīt līgumu',
      create: 'Izveidot līgumu',
      changeSignatureParty: 'Mainīt paraksta pusi',
      deleteSigned: 'Dzēst parakstīto līgumu',
    },
    parties: {
      Edu: 'Izglītības iestāde',
      Intern: 'Praktikants',
      Org: 'Prakses vieta',
    },
    upload: {
      hint: 'Augšupielādējiet .edoc vai .asice failu. Tajā jābūt visiem līdz šim pievienotajiem parakstiem un vismaz vienam jaunam.',
      file: 'Parakstītais līgums',
      fileRequired: 'Izvēlieties parakstīto līguma failu',
      party: 'Jauno parakstu puse',
      submit: 'Augšupielādēt',
    },
    reset: {
      confirm:
        'Līgums {{nr}} tiks dzēsts kopā ar visiem parakstiem un parakstīto failu. Tā vietā tiks izveidots jauns līgums ar jaunu numuru, kura dati būs jāpārbauda.',
      submit: 'Atiestatīt',
    },
    deleteSigned: {
      confirm:
        'Līgumam {{nr}} tiks dzēsti visi paraksti un parakstītais fails. Līguma numurs un dati paliek, un līgums būs jāparaksta no jauna.',
      submit: 'Dzēst',
    },
    create: {
      confirm:
        'Prakses vietai {{org}} tiks izveidots līgums ar nākamo numuru. Tā dati būs jāpārbauda.',
      submit: 'Izveidot',
    },
    changeParty: {
      hint: 'Norādiet, kurai pusei pieder katrs paraksts.',
      party: 'Puse — {{signatory}}',
      submit: 'Saglabāt',
    },
    editData: {
      sections: {
        org: 'Uzņēmums',
        signatory: 'Paraksttiesīgā persona',
        orgSupervisor: 'Uzņēmuma prakses vadītājs',
        eduSupervisor: 'Izglītības iestādes prakses vadītājs',
      },
      fields: {
        orgName: 'Nosaukums',
        orgRegNo: 'Reģistrācijas numurs',
        orgAddress: 'Juridiskā adrese',
        internshipPlace: 'Prakses vietas adrese',
        orgPhone: 'Tālrunis',
        orgEmail: 'E-pasts',
        orgFormal: 'Uzvārds, vārds',
        orgPK: 'Personas kods',
        orgReason: 'Pilnvarojums',
        orgSupervisor: 'Uzvārds, vārds',
        orgSupervisorPhone: 'Tālrunis',
        orgSupervisorEmail: 'E-pasts',
        eduSupervisor: 'Uzvārds, vārds',
        eduSupervisorPhone: 'Tālrunis',
        eduSupervisorEmail: 'E-pasts',
        additionalInfo: 'Papildu informācija',
      },
      required: 'Lauks nav aizpildīts',
      emailInvalid: 'Nepareizs e-pasts',
      save: 'Saglabāt',
      saved: 'Līguma dati saglabāti',
      loadFailed: 'Līguma datus neizdevās ielādēt',
      saveFailed: 'Līguma datus neizdevās saglabāt',
    },
    messages: {
      uploaded: 'Parakstītais līgums augšupielādēts',
      reset: 'Līgums atiestatīts',
      signedDeleted: 'Parakstītais līgums dzēsts',
      created: 'Līgums izveidots',
      partyChanged: 'Parakstu puses saglabātas',
      downloadError: 'Līgumu neizdevās lejupielādēt',
      failed: 'Darbība neizdevās',
    },
  },
  en: {
    title: 'Agreements',
    count_one: '{{count}} agreement',
    count_other: '{{count}} agreements',
    search: 'Search by intern, workplace, agreement number…',
    empty: 'No agreements found',
    statusTabs: 'Agreement status',
    tabs: {
      all: 'All',
      toSignEdu: 'Awaiting the institution’s signature',
      toSignOther: 'Awaiting other parties',
      inProcess: 'In process',
      missingData: 'Missing data',
      signed: 'Signed',
    },
    statuses: {
      toSignEdu: 'Awaiting the institution’s signature',
      toSignIntern: 'Awaiting the intern’s signature',
      toSignOrg: 'Awaiting the workplace’s signature',
      missingData: 'Missing data',
      missingOrg: 'No workplace',
      signed: 'Signed',
    },
    columns: {
      select: 'Select',
      nr: 'No.',
      agreementId: 'Agreement ID',
      intern: 'Intern',
      internship: 'Internship',
      org: 'Workplace',
      eduSigned: 'Institution signature',
      orgSigned: 'Workplace signature',
      internSigned: 'Intern signature',
      status: 'Status',
      agreementStart: 'Start',
      agreementEnd: 'End',
    },
    signing: {
      title: 'Signing agreements',
      processTitle: 'Signing process',
      signAt: 'Sign at',
      signAtEparaksts: 'Sign at eParaksts',
      sendToEmail: 'Send to email',
      sendDescription_one: 'A link to sign {{count}} agreement will be sent to this email.',
      sendDescription_other: 'A link to sign {{count}} agreements will be sent to this email.',
      email: 'Email',
      send: 'Send',
      sent: 'Signing link sent to {{email}}.',
      skipped_one: '{{count}} agreement was left out.',
      skipped_other: '{{count}} agreements were left out.',
    },
    eparakstsReturn: {
      title: 'Signing result',
      processing: 'Processing the signed agreements…',
      cancelled: 'Signing was cancelled.',
      failed: 'Signing failed ({{error}}).',
      notFound: 'The signing process was not found.',
      signedCount: 'Signed: {{count}} of {{total}}',
      result: 'Result',
      checkAgain: 'Check again',
    },
    emailSign: {
      title: 'Signing agreements',
      notFound: 'The link is not valid or has expired.',
      request: '{{sender}} asks you to sign the agreements as: {{party}}.',
      validUntil: 'The link is valid until {{date}}.',
      nothingToSign: 'There are no agreements left to sign in this link.',
      eduOrg: 'Educational institution',
    },
    notAssigned: 'Not assigned',
    signed: 'Signed',
    signedBy: 'Signed — {{signatory}}, {{date}}',
    notSigned: 'Not signed',
    selectAll: 'Select all visible',
    selectRow: 'Select {{name}}',
    signSelected: 'Sign selected ({{count}})',
    selectedNone: 'Select the agreements you want to sign',
    selectToSign: 'Select to sign',
    selectToDownload: 'Select to download',
    downloadSelected: 'Download selected ({{count}})',
    downloadSelectedNone: 'Select the agreements you want to download',
    filters: {
      button: 'Filters',
      title: 'Filter agreements',
      clear: 'Clear',
      apply: 'Apply filters',
      active: 'Active filters',
      remove: 'Remove “{{filter}}” filter',
      class: 'Class',
      group: 'Group',
      groupsSelected_one: '{{count}} group',
      groupsSelected_other: '{{count}} groups',
      groupsPill: 'Groups ({{total}})',
      internship: 'Internship',
      internshipsSelected_one: '{{count}} internship',
      internshipsSelected_other: '{{count}} internships',
      internshipsPill: 'Internships ({{total}})',
      pick: 'Select',
      template: 'Agreement template',
      nrPrefix: 'Prefix',
      status: 'Status',
      statuses: {
        toSignEdu: 'Ready to sign',
        toSignIntern: 'Waiting on intern',
        toSignOrg: 'Waiting on workplace',
        inProcess: 'In process',
        missingData: 'Missing data',
        missingOrg: 'Missing placement',
        signed: 'Signed',
      },
      all: 'All',
      inactive: '{{text}} (inactive)',
    },
    internshipPicker: {
      title: 'Select internships',
      class: 'Class',
      year: 'Year',
      allYears: 'All years',
      group: 'Group',
      status: 'Status',
      statuses: {
        all: 'All',
        ongoing: 'Current',
        upcoming: 'Future',
        finished: 'Ended',
      },
      search: 'Search by name, program or group',
      select: 'Select',
      none: 'No internships found',
      selected: 'Selected: {{total}}',
      clearSelection: 'Clear selection',
      apply: 'Select ({{total}})',
      loadFailed: 'Could not load internships',
    },
    groupPicker: {
      title: 'Select groups',
      class: 'Class',
      year: 'Year',
      allYears: 'All years',
      search: 'Search by name or description',
      select: 'Select',
      columns: {
        group: 'Group',
        class: 'Class',
        students: 'Students',
        description: 'Description',
      },
      none: 'No groups found',
      selected: 'Selected: {{total}}',
      clearSelection: 'Clear selection',
      apply: 'Select ({{total}})',
      loadFailed: 'Could not load groups',
    },
    actions: {
      menu: 'Agreement actions',
      sign: 'Sign',
      download: 'Download agreement',
      edit: 'Edit agreement data',
      uploadSigned: 'Upload signed agreement',
      reset: 'Reset agreement',
      create: 'Create agreement',
      changeSignatureParty: 'Change signing party',
      deleteSigned: 'Delete signed agreement',
    },
    parties: {
      Edu: 'Institution',
      Intern: 'Intern',
      Org: 'Workplace',
    },
    upload: {
      hint: 'Upload an .edoc or .asice file. It must contain every signature added so far and at least one new one.',
      file: 'Signed agreement',
      fileRequired: 'Choose the signed agreement file',
      party: 'Party of the new signatures',
      submit: 'Upload',
    },
    reset: {
      confirm:
        'Agreement {{nr}} will be deleted together with all its signatures and the signed file. A new agreement with a new number will be created in its place, and its data will need to be checked.',
      submit: 'Reset',
    },
    deleteSigned: {
      confirm:
        'All signatures and the signed file of agreement {{nr}} will be deleted. The agreement keeps its number and data and will need to be signed again.',
      submit: 'Delete',
    },
    create: {
      confirm:
        'An agreement with the next number will be created for the workplace {{org}}. Its data will need to be checked.',
      submit: 'Create',
    },
    changeParty: {
      hint: 'Choose which party each signature belongs to.',
      party: 'Party — {{signatory}}',
      submit: 'Save',
    },
    editData: {
      sections: {
        org: 'Company',
        signatory: 'Authorized signatory',
        orgSupervisor: 'Company supervisor',
        eduSupervisor: 'Institution supervisor',
      },
      fields: {
        orgName: 'Name',
        orgRegNo: 'Registration number',
        orgAddress: 'Legal address',
        internshipPlace: 'Internship location address',
        orgPhone: 'Phone',
        orgEmail: 'Email',
        orgFormal: 'Last name, first name',
        orgPK: 'Personal ID',
        orgReason: 'Authorization',
        orgSupervisor: 'Last name, first name',
        orgSupervisorPhone: 'Phone',
        orgSupervisorEmail: 'Email',
        eduSupervisor: 'Last name, first name',
        eduSupervisorPhone: 'Phone',
        eduSupervisorEmail: 'Email',
        additionalInfo: 'Additional information',
      },
      required: 'Field not filled',
      emailInvalid: 'Invalid email',
      save: 'Save',
      saved: 'Agreement data saved',
      loadFailed: 'The agreement data could not be loaded',
      saveFailed: 'The agreement data could not be saved',
    },
    messages: {
      uploaded: 'Signed agreement uploaded',
      reset: 'Agreement reset',
      signedDeleted: 'Signed agreement deleted',
      created: 'Agreement created',
      partyChanged: 'Signature parties saved',
      downloadError: 'The agreement could not be downloaded',
      failed: 'The action failed',
    },
  },
}
